module.exports = __webpack_public_path__ + "img/twitter.2c5d346c.svg";